import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalUnSuscribeSuccess extends React.Component {

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);

  }

  closeModal() {
    this.props.closeModal("UnSuscribeSuccess");
  }

  render() {
    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>x</Button>
          <h4 className="text-left">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className='modal-body text-center success'>
          <i className="fa text-center fa-3x fa-exclamation-triangle" aria-hidden="true"></i>
          <p className='padding-top-2' dangerouslySetInnerHTML={
          {__html: this.props.message}
          }></p>
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 padding-top-05">
                <Button             
                className={ classButtonInactive }
                onClick={ this.closeModal }>
                     Aceptar
                </Button> 
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    router: state.routing,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalUnSuscribeSuccess);
